import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import "../styles/landingPage.css";
import { ReactTyped } from "react-typed";
import { AuthContext } from "../context/AuthContext";
import Navbar from "./navbar";

export default function Landing() {
  const { userData } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (userData) {
      navigate("/home");
    } else {
      navigate("/auth");
    }
  };

  return (
    <div className="landingPageContainer">
      <div className="ambient-blob blob-1"></div>
      <div className="ambient-blob blob-2"></div>

      {/* Shared Navbar */}
      <Navbar />

      <div className="landingPageMainContainer">
        <div className="landingPageTextContainer">
          <h1 className="landingTitle">
            <span className="staticText">Connect with your</span>
            <br />
            <ReactTyped
              strings={[
                "<span class='highlight-text'>Loved Ones.</span>",
                "<span class='highlight-text'>Team.</span>",
                "<span class='highlight-text'>World.</span>",
              ]}
              typeSpeed={60}
              backSpeed={40}
              backDelay={1500}
              smartBackspace
              loop
            />
          </h1>

          <p className="landingSubtitle">
            Experience crystal clear video calls with low latency. Distance is
            just a word when the connection is this good.
          </p>

          <div className="buttonGroup">
            <button className="ctaBtn" onClick={handleGetStarted}>
              Get Started
            </button>
            <div className="users-preview">
              <span>🟢 10k+ Active Users</span>
            </div>
          </div>
        </div>

        <div className="landingPageImageContainer">
          <div className="image-glass-card">
            <img
              src="/mobile.jpg"
              alt="QuickMeet Mobile App"
              className="floating-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
